import { render, staticRenderFns } from "./PartnerTags.vue?vue&type=template&id=fe43a5d4&"
import script from "./PartnerTags.vue?vue&type=script&lang=js&"
export * from "./PartnerTags.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTags.vue?vue&type=style&index=0&id=fe43a5d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports